/**
 * Return the available breadcrumbs for a page
 * @param {object} page
 * @returns
 */
export const getPageBreadcrumbs = (page) => {
  let parent_page = getParent(page);
  let grandparent_page = getParent(parent_page);

  if (page?.ancestors?.nodes?.length > 0) {
    page.ancestors.nodes.forEach((ancestor, index) => {
      switch (index) {
        case 0:
          parent_page = ancestor;
          break;
        case 1:
          grandparent_page = ancestor;
          break;
      }
    });
  }

  if (parent_page && grandparent_page) {
    return { grandparent_page, parent_page, page };
  } else if (parent_page) {
    return { parent_page, page };
  }

  return null;
};

export const getParent = (page) => {
  let parent = page?.wpParent ? page.wpParent?.node : null;

  if (page?.ancestors?.nodes?.length > 0) {
    page.ancestors.nodes.forEach((ancestor, index) => {
      if (index === 0) {
        parent = ancestor;
      }
    });
  }

  return parent;
};

export const homeIfNoBreadcrumbs = (breadcrumbs, page) => {
  // Do not append home if the page is the home page
  if ((page?.link || page?.uri) === '/') {
    return breadcrumbs;
  }

  if (!breadcrumbs) {
    return { parent_page: { title: 'Home', link: '/', uri: '/' }, page };
  }
  return breadcrumbs;
};
